export default __webpack_public_path__ + "static/media/dots.2057a46d.svg";